<template>
  <div class="Home">
    <div class="pcblock">
      <div class="banner" @click="openSignDialog" v-if="!isMobile">
        <img
          src="https://gyyc-jctxpx.oss-cn-beijing.aliyuncs.com/public-image/banner.jpg"
          alt=""
        />
      </div>
      <div class="homebox1">
        <div class="home-title padb10">
          <img src="../../assets/image/Property-left.svg" alt="" />
          培训信息
          <img src="../../assets/image/Property-right.svg" alt="" />
        </div>
        <div class="home-content home-text text-center">
          为贯彻落实国家卫生健康委关于2026年卫生健康系统为民服务实事项目和《医疗卫生强基工程实施方案》的有关要求，加强基层透析服务供给和综合能力提升，进一步完善透析中心建设，提升透析服务质量和可及性，国家卫生健康委人口文化与基层健康中心发起并主办“基层透析服务能力提升项目”，围绕标准制订、能力培训、竞赛展示、科普建设四大核心任务，面向以中西部省份为主的县域基层透析从业人员开展系统化能力提升工作。
        </div>
      </div>
      <div class="homebox1">
        <div class="boxitem">
          <h3>一、培训对象</h3>
          <div class="home-text">
            县医院透析中心的医生、护士、技师和管理人员。
          </div>
        </div>
        <div class="boxitem padb10">
          <h3>二、培训形式</h3>
          <div class="home-text">
            线上理论教学（1-3月）：基础理论 + 标准解读 + 典型病例；<br />
            线下实操集训（3天）：理论深化 + 病例解析 + 操作演示/实训；<br />
            考核发证：理论考试 + 操作考核 + 主办单位颁发《培训合格证书》。
          </div>
        </div>
        <div class="boxitem padb10">
          <h3>三、培训范围</h3>
          <div class="home-text">
            每场线下培训以一个地级市为培训单元，辐射周边约10个区县，覆盖约30家透析中心，参训人数约150人；<br />
            2026年举办30场线下培训，对应30个地级市，辐射周边约300个区县，覆盖约900家透析中心，参训人数约4500人；<br />
            2026-2030年共计举办280场线下培训，对应280个地级市，辐射周边约2800个区县，覆盖约8400家透析中心，参训人数约42000人。
          </div>
        </div>
        <div class="boxitem padb10">
          <h3>四、培训日程</h3>
          <div class="home-text">
            具体培训时间和地点以报名平台最新发布为准。
          </div>
          <div class="imginfo">
            <img
              src="https://gyyc-jctxpx.oss-cn-beijing.aliyuncs.com/public-image/tableview.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 报名按钮 -->
      <div class="btnbox">
        <div class="signbtn text-center" @click="openSignDialog">立即报名</div>
      </div>
      <!-- 对话框 -->
      <el-dialog
        title="报名"
        :visible.sync="SignDialog"
        :width="isMobile ? '100%' : '40%'"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <div class="mobileblock">
          <signModule :hasRegistered="hasRegistered"></signModule>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import signModule from "../../components/signModule.vue";
import { hasToken } from "../../assets/js/storage";
import { getRegistrationInfo } from "../API/user";
import { loginTicket } from "../API/login";
import { setToken } from "../../assets/js/storage";
export default {
  props: ["isWeChat"],
  data() {
    return {
      hasRegistered: false,
      SignDialog: false,
      isMobile: document.body.clientWidth < 540 ? true : false,
      needBindMobile: false,
    };
  },
  components: { signModule },
  created() {
    console.log("isWeChat", this.isWeChat);
    this.wechatloginHandle();
  },
  mounted() {},
  methods: {
    async wechatloginHandle() {
      const ticket = this.getQueryParam("ticket")
        ? this.getQueryParam("ticket")
        : "";
      console.log("ticket:" + ticket);
      if (ticket && !hasToken()) {
        const res = await loginTicket({ ticket });
        if (res.data.code === 1) {
          this.needBindMobile = res.data.data.needBindMobile;
          setToken(res.data.data.accessToken);
          if (this.needBindMobile) {
            this.$emit("openbindDialog");
          } else {
            // 登录成功
            this.$message({
              message: "登录成功",
              type: "success",
            });
            localStorage.setItem(
              "UserInfo",
              JSON.stringify(res.data.data.userInfo),
            );
            return this.$router.push({ name: "User" });
          }
        } else {
          localStorage.clear();
          this.$router.push({ name: "Home" });
        }
      }
    },
    getQueryParam(name) {
      const regex = new RegExp("[?&]" + name + "=([^&]*)");
      const results = regex.exec(window.location.search);
      return results ? decodeURIComponent(results[1]) : null;
    },
    // 检测报名状态
    async getReInfo() {
      let isUserInfo = localStorage.getItem("UserInfo") ? true : false;
      const { data: res } = await getRegistrationInfo();
      this.hasRegistered = res.data.hasRegistered;
      if (!this.hasRegistered) {
        if (!isUserInfo) {
          this.$message.warning("您还未绑定手机号");
          return this.$emit("openbindDialog");
        } else {
          this.SignDialog = true;
        }
      } else {
        return this.$message.warning("您已经报名过了");
      }
    },
    handleClose() {
      this.SignDialog = false;
    },
    openSignDialog() {
      if (hasToken()) {
        // 检测报名状态
        this.getReInfo();
      } else {
        this.$emit("openLoginDialog");
        this.$message.warning("请您先登录");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.Home {
  width: 100%;
  overflow: hidden;
  background: #f9faff;
  .mobileblock {
    padding: 20px 14px;
  }
  .footer {
    background: #f7faff;
  }
  .flex-layout {
    display: flex;
    align-items: center;
    @media screen and (max-width: 540px) {
      display: block;
    }
  }
  .pcblock {
    width: 62%;
    margin: 20px auto;
    padding-bottom: 30px;
    background: #ffffff;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    @media screen and (max-width: 540px) {
      margin: 0 auto;
    }
    .banner {
      height: 375px;
      background: #eee;
      cursor: pointer;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    @media screen and (max-width: 540px) {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .text-center {
      text-align: center;
    }
    .btnbox {
      padding: 50px 0;
      .signbtn {
        margin: auto;
        width: 248px;
        height: 60px;
        line-height: 60px;
        background: linear-gradient(86deg, #6f44a1 0%, #05258e 100%);
        box-shadow: 0px 8px 17px 0px #c3cbe5;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
        color: #ffffff;
        border-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 1)
          )
          1 1;
      }
    }

    .text-left {
      text-align: left !important;
    }
    .home-title {
      font-weight: bold;
      font-size: 30px;
      color: #05258e;
      text-align: center;
      @media screen and (max-width: 540px) {
        font-size: 24px;
      }
    }
    .home-content {
      padding: 0 100px;
      @media screen and (max-width: 540px) {
        padding: 0;
        padding: 0 20px;
      }
    }
    .padb10 {
      padding-bottom: 10px;
    }
    .padb20 {
      padding-bottom: 20px;
    }
    .pad20 {
      padding: 20px !important;
    }
    .margr20 {
      margin-right: 20px;
      @media screen and (max-width: 540px) {
        margin-right: 0;
      }
    }
    .padl20 {
      padding-left: 20px;
    }
    .boxitem {
      padding: 0 20px;
      padding-top: 30px;
      h3 {
        padding-bottom: 10px;
        color: #05258e;
      }
      .imginfo {
        img {
          width: 100%;
          @media screen and (max-width: 540px) {
          }
        }
        @media screen and (max-width: 540px) {
          padding: 0 1px;
        }
      }
    }
    .boxitem2 {
      padding: 10px 20px;
      background: #e9ecf9;
      font-size: 18px;
      margin-bottom: 20px;
      flex: 1;
      h4 {
        text-align: center;
        font-weight: normal;
        font-size: 16px;
        padding-bottom: 10px;
      }
      h3 {
        font-size: 20px;
        text-align: center;
        color: #6f44a1;
        @media screen and (max-width: 540px) {
          font-size: 18px;
        }
      }
      span {
        padding-right: 30px;
        color: #05258e;
        font-weight: bold;
        @media screen and (max-width: 540px) {
          display: block;
        }
      }
      h5 {
        font-size: 18px;
        font-weight: normal;
        display: inline-block;
        @media screen and (max-width: 540px) {
          display: block;
          padding-left: 18px;
          padding-top: 10px;
        }
      }
      .itemdate {
        color: #05258e;
      }
      a {
        color: #000;
      }
      p {
        text-align: center;
        font-size: 16px;
      }
      .itemtitle {
        padding: 10px 0;
        font-weight: bold;
        color: #05258e;
        font-size: 20px;
      }
    }
    .home-text {
      font-weight: 400;
      font-size: 18px;
      line-height: 32px;
      color: #232426;
    }
    .homebox1 {
      padding-top: 50px;
      padding-bottom: 20px;
      @media screen and (max-width: 540px) {
        padding-top: 20px;
        padding-bottom: 10px;
      }
    }
    .homebox {
      padding: 30px 40px;
      background-color: #f3f6ff;
      border-radius: 10px;
      margin-bottom: 40px;
      @media screen and (max-width: 540px) {
        padding: 10px;
        margin-bottom: 20px;
      }
    }
    .homeborder {
      border: 2px solid #e9ecf9;
    }
  }
}
</style>
